import React from 'react';
import classNames from 'classnames';
import QuestionGroupHeader from '../QuestionGroupHeader.jsx';
import { getMessages } from '../../../i18n/messageUtil.mjs';
import { useIntl } from 'react-intl';
import ReactSVG from 'react-svg';
import PropTypes from 'prop-types';
import {QuestionGroupViewPropTypes} from '../../../shapes/index';
import {useText} from '../../TextContext';

const Icon = (props) => {
  const {
    questionGroup,
    renderChildren,
    className
  } = props;

  const intl = useIntl();
  const textContext = useText();

  const classes = classNames(
    className,
    'questionGroup--icon'
  );

  const getIcon = () => {
    const messages = getMessages(intl.locale);
    const key = `${ questionGroup.key }.icon`;
    if (Object.prototype.hasOwnProperty.call(messages, key)) {
      return textContext?.[`${key}`] || <ReactSVG src={ messages[key] }/>;
    }
    return null;
  };

  return (
    <div>
      <section className={ classes }>
        <QuestionGroupHeader questionGroup={ questionGroup }/>
        { renderChildren() }
      </section>
      <section className="iconContainer">
        <div className="icon">{ getIcon() }</div>
      </section>
    </div>
  );
};

Icon.propTypes = {
  ...QuestionGroupViewPropTypes,
  questionGroup: PropTypes.any
};

export default Icon;
